import { CHATBOT_CUSTOM_CODE_VIEW_STATE } from "../actions/chatbotCustomCodeView.action";
import { IChatbotCustomCodeViewState } from "../models/root.interface";

const initialState: IChatbotCustomCodeViewState = {
    isVisible: false
}

const chatbotCustomCodeViewReducer = (state: IChatbotCustomCodeViewState = initialState, action: any): IChatbotCustomCodeViewState => {

    switch (action.type) {
        case CHATBOT_CUSTOM_CODE_VIEW_STATE:
            return {
                ...state,
                isVisible: action.isVisible
            }
        default:
            return state;
    }
}

export default chatbotCustomCodeViewReducer;